import { render, staticRenderFns } from "./edgeworkSelection.vue?vue&type=template&id=51d0db79&scoped=true&"
import script from "./edgeworkSelection.vue?vue&type=script&lang=js&"
export * from "./edgeworkSelection.vue?vue&type=script&lang=js&"
import style0 from "./edgeworkSelection.vue?vue&type=style&index=0&id=51d0db79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d0db79",
  null
  
)

export default component.exports